import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TR from './../../Trans';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Capacitor } from '@capacitor/core';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Error from './../items/Error';
import Stack from '@mui/material/Stack';
import Message from './../items/Message';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import Waiting from './../items/Waiting';
import navigationStore from '../../stores/navigation';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from './../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import statusStore from './../../stores/status';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from './../dialogs/UpdateDialog';
import MessageDialog from './../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import IntervalService from './../../services/intervals';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from './../../stores/bgPlaylists';
import songbookQueueStore from './../../stores/songbookQueue';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function resetStores() {
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: false,
    isAndroidSubMode: false
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearSubInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();
  
}

function StartRegister() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const logout = sessionStore((state) => state.logout);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      resetStores();
      logout();
    }
    document.title = TR.ww_page_title;
  });

  return <Navigate to="/startregister" />;
}

export default StartRegister;